module.exports = __webpack_public_path__ + "static/media/WatchThisEveryday.27abbd66.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/components/Motivation/WatchThisEveryday/WatchThisEveryday.mp4
// module id = 391
// module chunks = 0